import { format } from "date-fns";
import React from "react";
import { Exercise } from "../../../models/Exercise";
import "../style.scss";
import "../../../../style/block.scss";
import "../../../../style/hovers.scss";
import { BsArrowRight, BsCircle } from "react-icons/bs";
import { BiBlock } from "react-icons/bi";
import HtmlTooltip from "@mui/material/Tooltip";
import { HiOutlineTicket } from "react-icons/hi";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import { useTranslation } from "react-i18next";
import getId from "../../../../utils/getId";

interface IProps {
  exercise: Exercise[];
  getTicketsByExercise: (id: number, exercises: Exercise) => void;
  handleWhichClicked: (index: number) => void;
  handleCloseModal?: (boolean: boolean) => void;
  getDetailsAboutClickedExercise: (exerciseId: number) => void;
  whichClicked: number;
}

const CalendarExerciseChoice: React.FC<IProps> = ({
  getDetailsAboutClickedExercise,
  exercise,
  getTicketsByExercise,
  handleCloseModal,
  handleWhichClicked,
  whichClicked,
}: IProps) => {
  const { t } = useTranslation();
  const showTimeOfEntance = useSelector((state: State) => state.config.configuration.showTimeOfEntance);
  const qntState = useSelector((state: State) => state.basket.calendarSaleQntState);

  const getQntStateCount = (itemId: string) => {
    const findedItems = qntState.filter((qntItem) => qntItem.exerciseIds === itemId);
    const totalCount = findedItems.reduce((total, currentItem) => total + currentItem.count, 0);
    return totalCount;
  };

  return (
    <React.Fragment>
      {exercise && (
        <React.Fragment>
          {exercise.map((item, index) => (
            <React.Fragment>
              {item.capacity > item.reserved + item.prereservation ? (
                <div
                  className={
                    index === whichClicked
                      ? "active-hour-single hour-single flex-between-center flex-center-center flex-wrap move-up"
                      : "hour-single flex-between-center flex-center-center flex-wrap move-up"
                  }
                  key={index}
                  onClick={() => {
                    getDetailsAboutClickedExercise(item.objectId);
                    getTicketsByExercise(item.exerciseGroup.objectId, item);
                    handleWhichClicked(index);
                    if (handleCloseModal) handleCloseModal(false);
                  }}
                >
                  {index !== whichClicked && <BsCircle className="icon" />}
                  {index === whichClicked && <BsArrowRight className="icon" />}

                  <b className="flex-between-center">
                    {format(item.startTime, "HH:mm")}
                    {showTimeOfEntance === true ? (
                      <React.Fragment>- {format(item.closeTime, "HH:mm")}</React.Fragment>
                    ) : (
                      <div className="ticket-left flex-center-center">
                        {item.capacity - (item.prereservation + item.reserved)}
                        <HiOutlineTicket className="alert-icon" />
                        {getQntStateCount(String(item.objectId)) > 0 && (
                          <div className="ticket-selected-count">{getQntStateCount(String(item.objectId))}</div>
                        )}
                      </div>
                    )}
                  </b>
                </div>
              ) : (
                <React.Fragment>
                  <HtmlTooltip
                    placement="right"
                    title={
                      <React.Fragment>
                        <div className="alert alert-red">{t("wszystkie_bilety_zostaly_sprzedane")}</div>
                      </React.Fragment>
                    }
                  >
                    <div className="hour-single-disable hour-single flex-between-center flex-center-center flex-wrap">
                      <BiBlock className="icon" />
                      <b className="flex-between-center">
                        {format(item.startTime, "HH:mm")}

                        {showTimeOfEntance === true ? (
                          <React.Fragment>- {format(item.closeTime, "HH:mm")}</React.Fragment>
                        ) : (
                          <div className="ticket-left flex-center-center">
                            {item.capacity - (item.prereservation + item.reserved)! > 0 ? (
                              <React.Fragment>{item.capacity - (item.prereservation + item.reserved)}</React.Fragment>
                            ) : (
                              <React.Fragment>0</React.Fragment>
                            )}

                            <HiOutlineTicket className="alert-icon" />
                          </div>
                        )}
                      </b>
                    </div>
                  </HtmlTooltip>
                </React.Fragment>
              )}
            </React.Fragment>
          ))}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default CalendarExerciseChoice;
